module.exports = __webpack_public_path__ + "img/legend_item.94eb45fc.png";